(function(){
  if (window.__bbHome) return; window.__bbHome = 1;
  var els = document.querySelectorAll('.bh [data-rv]');
  if (!('IntersectionObserver' in window) || !els.length) return;
  document.documentElement.classList.add('bh-js');
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('bh-in'); io.unobserve(e.target); } });
  }, {rootMargin: '0px 0px -8% 0px', threshold: 0.08});
  els.forEach(function(el, i){
    var sib = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
    el.style.transitionDelay = Math.min(sib, 5) * 70 + 'ms';
    io.observe(el);
  });
})();
